import React from 'react'
import { IonRow, IonCol } from '@ionic/react'
import { capitalizeString } from '../../../utils/utils'
import { TextLink, Subtitulo, Titulo, CardSolicitarAsistencia } from 'app-principal-componentes-visuales'
import { Direccion } from '../../../interfaces/direccion.interface'
import { CAPITAL } from '../../../utils/constants'
import { SocioFamiliar } from '../../../interfaces/socioFamiliar.interface'
import { Socio } from '../../../models/socioPrincipal.model'
import "./DireccionSeleccionadaComponent.scss"

interface DireccionSeleccionadaComponentProps {
    selectedDirection: Direccion,
    handleCambiarUbicacion: () => void,
    handleAgregarNuevoDomicilio: () => void,
    socio: Socio | SocioFamiliar,
}

const DireccionSeleccionadaComponent = ({ selectedDirection, handleCambiarUbicacion, handleAgregarNuevoDomicilio, socio }: DireccionSeleccionadaComponentProps) => {
    return (
        <div className='direccion__seleccionada__component'>
            <IonRow>
                <IonCol size="12">
                    <Titulo
                        titulo="Confirma tu dirección"
                        id="subtitulo-ubicacion-ysocial"
                    />
                    <Subtitulo
                        txt14
                        titulo={
                            "Para agilizar una posible asistencia médica después de tu consulta online."
                        }
                        id="subtitulo-seleccionar-domicilio"
                    />
                </IonCol>
            </IonRow>

            {selectedDirection ? (
                <>
                    <IonRow className='row-radio-button'>
                        <IonCol size="12" className="contenido-inputs">
                            <CardSolicitarAsistencia
                                descripcion={
                                    selectedDirection.provincia == CAPITAL
                                        ? "Ciudad Autónoma de Buenos Aires"
                                        : capitalizeString(selectedDirection.provincia)
                                }
                                id="ysocial-card-direcciones"
                                tipoTramite={
                                    capitalizeString(
                                        `${selectedDirection?.calle}${
                                            !selectedDirection?.barrioCerrado ? 
                                            ` ${selectedDirection?.altura}${selectedDirection?.barrio && ', ' + selectedDirection?.barrio}` 
                                            : `, ${selectedDirection?.localidad}`
                                        }`)
                                    }
                            />
                        </IonCol>
                    </IonRow>
                    {
                        socio?.telefono && socio?.email &&
                        <IonRow>
                            <IonCol>
                                <TextLink
                                    id="cambiar-ubicacion-ysocial"
                                    onClick={() => handleCambiarUbicacion()}
                                    right
                                    texto="Seleccionar otro domicilio"
                                />
                            </IonCol>
                        </IonRow>
                    }
                </>
            ) : (
                <>
                    <IonRow className="row-no-datos">
                        <Subtitulo
                            txt16
                            className="domicilios_card"
                            txtCenter
                            titulo={"No tenés domicilios registrados"}
                            id="subtitulo-domicilio"
                        />
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <TextLink
                                id="cambiar-ubicacion-ysocial"
                                onClick={handleAgregarNuevoDomicilio}
                                right
                                texto="Agregar nuevo domicilio"
                            />
                        </IonCol>
                    </IonRow>
                </>
            )}
        </div>
    )
}

export default DireccionSeleccionadaComponent